/**
 * 1.3.1 (Q2): the Media portal's statistics (Administration → Statistics) and the reminders sent (Media portal →
 * Settings). The statistics key starts with ['statistics'], so the Statistics page's Refresh now refreshes it too;
 * the reminders key starts with portalAdmin(), so saving the portal's settings refreshes it.
 */
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import type { PortalRangeFiguresDTO, PortalReminderRowDTO, PortalStatisticsDTO, StatisticsRange } from '@prism/contracts';
import { api } from '../client';
import { queryKeys } from '../queryKeys';

/** The range's figures (no month): the tiles. */
export type PortalRangeFigures = PortalRangeFiguresDTO;
/** PortalStatisticsDTO with the range's summary. */
export type PortalStatisticsResponse = PortalStatisticsDTO;

export type { PortalReminderRowDTO };

export const portalStatisticsKey = (range: StatisticsRange) => ['statistics', 'portal', range] as const;
export const portalRemindersKey = () => [...queryKeys.portalAdmin(), 'reminders'] as const;

export function usePortalStatistics(range: StatisticsRange) {
  return useQuery({
    queryKey: portalStatisticsKey(range),
    queryFn: () => api<PortalStatisticsResponse>(`/api/v1/statistics/portal?range=${range}`),
    refetchInterval: 60_000, placeholderData: keepPreviousData,
  });
}

export function usePortalReminders(limit = 10) {
  return useQuery({
    queryKey: [...portalRemindersKey(), limit],
    queryFn: () => api<{ items: PortalReminderRowDTO[] }>(`/api/v1/admin/portal/reminders?limit=${limit}`),
  });
}
